import { Tag, TagLabel, TagCloseButton } from '@chakra-ui/react'

export const ColumnSettingsTag = ({label, onRemove}) => {

return (
    <Tag mr='2' size='md' my='1' borderRadius='full' variant='solid' colorScheme='green'>
        <TagLabel>{label}</TagLabel>
        <TagCloseButton onClick={onRemove} />
    </Tag>
)
}